import { FunctionComponent, useState } from 'react'
import Modal from '@/components/Modal'
import { CopyToClipboard } from '@/components/CopyToClipboard'
import { RenderIf } from '@/components/RenderIf'
import { inviteToVideoCall } from '../../video-call-services'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './styles'
import type { InviteToCallModalProps } from './types'
import { Input, toast, Text } from '@conexasaude/conexa-hero'

const InviteToCallModal: FunctionComponent<InviteToCallModalProps> = ({
  sessionId,
}) => {
  const [guestName, setGuestName] = useState('')
  const [inviteLink, setInviteLink] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { closeModal } = useModalContext()
  const styles = useStyles()

  const generateInviteLink = () => {
    setIsLoading(true)
    inviteToVideoCall(sessionId, guestName)
      .then(data => {
        setInviteLink(data.object)
      })
      .catch(err => {
        const errorMessage =
          err?.response?.data?.msg || err?.response?.msg || err?.message

        toast({
          message: errorMessage,
          variant: 'error',
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const clearModalData = () => {
    setGuestName('')
    setInviteLink('')
  }

  const closeAndClearModal = () => {
    clearModalData()
    closeModal()
  }

  return (
    <Modal
      id="INVITE_TO_CALL_MODAL"
      onDismiss={clearModalData}
      primaryAction={generateInviteLink}
      primaryActionLabel="Gerar link"
      disabledPrimaryAction={!guestName || isLoading || !!inviteLink}
      busyPrimaryAction={isLoading}
    >
      <div css={styles.contentWrapper}>
        <Text>Digite o nome do convidado para gerar o link da chamada.</Text>

        <div css={styles.inputWrapper}>
          <Input
            value={guestName}
            onChange={event => setGuestName(event.target.value)}
            label="Nome do convidado"
            placeholder="Digite o nome do convidado"
          />
        </div>

        <RenderIf condition={!!inviteLink}>
          <div css={styles.copyToClipboardWrapper}>
            <CopyToClipboard
              onActionClick={() => closeAndClearModal()}
              value={inviteLink}
            />
          </div>
        </RenderIf>
      </div>
    </Modal>
  )
}

export default InviteToCallModal
